/* global angular */
( function () {
	'use strict';

	function DragController ( collectionService, ERROR_MSGS, logger ) {
		var self = this;

		function moveItemUpHandler ( collection, indicator ) {
			collectionService.moveModel( collection, indicator, collectionService.moveUp );
		}

		function moveItemDownHandler ( collection, indicator ) {
			collectionService.moveModel( collection, indicator, collectionService.moveDown );
		}

		function cutItemHandler ( group, indicator ) {
			if ( ( group.formula || '' ).indexOf( indicator.id ) < 0 ) {
				self.isMoving       = true;
				self.focusGroup     = group;
				self.focusIndicator = indicator;

				return;
			}

			logger.notifyError( ERROR_MSGS.indicatorDeleteError );
		}

		function pasteItemHandler ( group ) {
			collectionService.addModel( group.indicators, self.focusIndicator );
			collectionService.removeModel( self.focusGroup.indicators, self.focusIndicator );
			self.reset();
		}

		function isFocusGroupHandler ( group ) {
			return self.focusGroup === group;
		}

		function isFocusIndicatorHandler ( indicator ) {
			return self.focusIndicator === indicator;
		}

		// handlers
		self.moveItemUpHandler   = moveItemUpHandler;
		self.moveItemDownHandler = moveItemDownHandler;
		self.cutItem             = cutItemHandler;
		self.isFocusGroup        = isFocusGroupHandler;
		self.pasteItem           = pasteItemHandler;
		self.isFocusIndicator    = isFocusIndicatorHandler;
	}

	angular
		.module( 'app.templates' )
		.controller( 'DragController', DragController );

	DragController.$inject = [ 'collectionService', 'ERROR_MSGS', 'logger' ];
} )( );
